import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'parseThreat',
    standalone: false
})
export class ParseThreatPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}

  transform(value: string): string {
    const UIDRegex = /([a-zA-Z0-9]{40})/g;
    const URLRegex = /"[^"]*"|(https?:\/\/[a-zA-Z0-9-_.\/]+\b)/g;

    let output = value.replace(
      URLRegex,
      '<a class="internal-link" data-link-ext="$1">$1</a>'
    );
    output = output.replace(
      UIDRegex,
      '<a class="internal-link" data-link="$1">$1</a>'
    );

    return this.sanitized.bypassSecurityTrustHtml(output) as string;
  }
}
